export default {
  nav: {
    categories: 'Kategorier',
    topSites: 'Toppnettsteder',
    compare: 'Sammenlign',
    submitSite: 'Send inn nettsted',
    about: 'Om',
    logIn: 'Logg inn',
  },
  common: {
    back: 'Tilbake',
    search: 'Søk',
    loading: 'Laster…',
    viewSimilarSites: 'Se lignende nettsteder',
  },
  hero: {
    badge: 'Nettstedsøk-motor',
    titleA: 'Finn nettsteder som ligner på',
    titleB: 'dine favoritter.',
    titlePrefix: 'Finn nettsteder som ligner på',
    titleAccent: 'dine favoritter.',
    subtitle: 'Oppdag konkurrenter, alternativer og skjulte perler på nettet med presise likhetspoeng.',
    placeholder: 'Skriv inn et domene (f.eks. stripe.com)',
    inputPlaceholder: 'Skriv inn et domene (f.eks. stripe.com)',
    step1Label: 'Skriv inn et domene',
    step1Desc: 'Skriv inn en nettadresse for å starte',
    step2Label: 'Få treff',
    step2Desc: 'Motoren finner lignende nettsteder umiddelbart',
    step3Label: 'Sammenlign og velg',
    step3Desc: 'Analyser og sammenlign alternativer',
    steps: {
      step1Label: 'Skriv inn et domene',
      step1Desc: 'Skriv inn en nettadresse for å starte',
      step2Label: 'Få treff',
      step2Desc: 'Motoren finner lignende nettsteder umiddelbart',
      step3Label: 'Sammenlign og velg',
      step3Desc: 'Analyser og sammenlign alternativer',
    },
  },
  footer: {
    newsletterTitle: 'Hold deg oppdatert',
    newsletterDesc: 'Få ukentlige rapporter om trender og nye alternativer.',
    emailPlaceholder: 'din@epost.no',
    subscribe: 'Abonner',
    brandDesc: 'Oppdag skjulte forbindelser på nettet. Finn lignende nettsteder med presis vurdering.',
    explore: 'Utforsk',
    popular: 'Populært',
    company: 'Selskap',
    compareSites: 'Sammenlign nettsteder',
    sitesLike: 'Nettsteder som',
    contact: 'Kontakt',
    faq: 'FAQ',
    removeYourSite: 'Fjern nettstedet ditt',
    privacyPolicy: 'Personvern',
    termsOfService: 'Vilkår',
    rights: 'Alle rettigheter reservert.',
  },
  notFound: {
    title: 'Oops! Siden ble ikke funnet',
    returnHome: 'Tilbake til forsiden',
  },
  submitPage: {
    ctaTitle: 'Kjenner du en bra nettside?',
    ctaDesc: 'Hjelp oss å vokse ved å sende inn sider du liker. Det tar bare noen sekunder.',
    ctaButton: 'Send inn nettsted',
    pageTitle: 'Send inn nettsted',
    pageSubtitle: 'Send inn et nettsted som skal indekseres hos oss.',
    successTitle: 'Nettsted sendt inn!',
    successReviewPrefix: 'Vi vurderer',
    successReviewSuffix: 'og legger den snart til i indeksen vår.',
    backHome: 'Tilbake til forsiden',
    domainLabel: 'Domene *',
    domainPlaceholder: 'f.eks. example.com',
    descriptionLabel: 'Beskrivelse',
    descriptionPlaceholder: 'Kort beskrivelse av nettstedet',
    categoryLabel: 'Kategori',
    categorySelect: 'Velg kategori',
    alternativeTo: 'Alternativ til (valgfritt)',
    alternativeNone: 'Ingen — ikke et alternativ',
    emailLabel: 'Din e-post',
    emailPlaceholder: 'deg@eksempel.no',
    submitButton: 'Send inn',
    submitFailed: 'Kunne ikke sende inn',
    seoTitle: 'Send inn nettsted | CiteMatch',
    seoDesc: 'Send inn et nettsted for indeksering på CiteMatch.',
  },
};

